import React, { useEffect } from 'react';
import { StickyNav } from '../components/StickyNav';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ProblemSection } from '../components/ProblemSection';
import { OldSolutionsSection } from '../components/OldSolutionsSection';
import { MechanismSection } from '../components/MechanismSection';
import { CTASection } from '../components/CTASection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#F5F0EB] font-sans text-neutral-900 selection:bg-amber-100 selection:text-amber-900" data-id="element-223">
      <StickyNav data-id="element-224" />
      <main data-id="element-225">
        <HeroSection data-id="element-226" />
        <PainSection data-id="element-227" />
        <ProblemSection data-id="element-228" />
        <OldSolutionsSection data-id="element-229" />
        <MechanismSection data-id="element-230" />
        <CTASection data-id="element-231" />
        <FAQSection data-id="element-232" />
        <CTASection data-id="element-233" />
      </main>
      <Footer data-id="element-234" />
    </div>;
}